import React, { ReactElement } from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormSelect from "./FormSelect";
import { FormProps } from "./FormProps";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import { ControllerProps } from "react-hook-form";
import { MenuItem, SelectProps, SwitchProps } from "@mui/material";

function FormSelectTC(
  props: FormProps & {
    options: ReactElement<typeof MenuItem>[];
    defaultValue?: string;
  } & Translation & {
      rules?: ControllerProps["rules"];
    } & {
      fieldProps?: SelectProps;
    }
) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormSelect defaultValue={props.defaultValue} name={props.name} options={props.options} />
    </FormFieldTwoColumns>
  );
}

FormSelectTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),

  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
};

export default FormSelectTC;
